import React, { useState, useEffect } from "react";
import { Box, Paper } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import SidePanel from "../../components/SidePanel";
import TopBar from "../../components/TopBar";
import PartnerAgents from "./sections/PartnerAgents";
import PartnerCars from "./sections/PartnerCars";
import PartnerDrivers from "./sections/PartnerDrivers";
import PartnerOwners from "./sections/PartnerOwners";
import PartnerRides from "./sections/PartnerRides";
import PartnerTransactions from "./sections/PartnerTransactions";
import PartnerMap from "./sections/PartnerMap";
import PartnerSettings from "./sections/PartnerSettings";

const PartnerDashboard: React.FC = () => {
  const [partnerId, setPartnerId] = useState<string | null>(null);
  const [userRole, setUserRole] = useState<string>("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded: any = jwtDecode(token);
      // For partner agents, use partnerId (the partner they belong to)
      // For partners, use their own _id
      if (decoded.role === "partner-agent") {
        setPartnerId(decoded.partnerId);
      } else {
        setPartnerId(decoded._id);
      }
      setUserRole(decoded.role);
      
      // If on partner-dashboard route without a section, redirect to first available section
      if (location.pathname === "/partner-dashboard") {
        if (decoded.role === "partner") {
          navigate("/partner-dashboard/agents", { replace: true });
        } else if (decoded.role === "partner-agent") {
          const permissions = decoded.permissions || {};
          // Redirect to first available section based on permissions
          if (permissions.canViewCars !== false) {
            navigate("/partner-dashboard/cars", { replace: true });
          } else if (permissions.canViewDrivers !== false) {
            navigate("/partner-dashboard/drivers", { replace: true });
          } else if (permissions.canViewOwners !== false) {
            navigate("/partner-dashboard/owners", { replace: true });
          } else if (permissions.canViewTransactions !== false) {
            navigate("/partner-dashboard/transactions", { replace: true });
          } else if (permissions.canViewMap !== false) {
            navigate("/partner-dashboard/map", { replace: true });
          }
        }
      }
    }
  }, [location.pathname, navigate]);

  if (!partnerId) {
    return <Box>Loading...</Box>;
  }

  // Get current section from route
  const currentSection = location.pathname.split("/").pop() || "";

  const renderSection = () => {
    switch (currentSection) {
      case "agents":
        if (userRole === "partner") {
          return <PartnerAgents partnerId={partnerId} />;
        }
        return null;
      case "cars":
        return <PartnerCars partnerId={partnerId} />;
      case "drivers":
        return <PartnerDrivers partnerId={partnerId} />;
      case "owners":
        return <PartnerOwners partnerId={partnerId} />;
      case "rides":
        return <PartnerRides partnerId={partnerId} />;
      case "transactions":
        return <PartnerTransactions partnerId={partnerId} />;
      case "map":
        return <PartnerMap partnerId={partnerId} />;
      case "settings":
        if (userRole === "partner") {
          return <PartnerSettings partnerId={partnerId} />;
        }
        return null;
      default:
        return <Box>Select a section from the sidebar</Box>;
    }
  };

  return (
    <Box className="mainContainer">
      <Box className="sidePanelContainer">
        <SidePanel isOpen={true} onClose={() => {}} />
      </Box>
      <Box className="dashboardContainer">
        <TopBar />
        <Box sx={{ width: "100%", padding: "20px", marginTop: "5%" }}>
          <Paper elevation={3} sx={{ padding: "20px" }}>
            {renderSection()}
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default PartnerDashboard;

